import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b9993a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "pl-8 pr-8 min-h-screem" }
const _hoisted_3 = {
  key: 1,
  class: "flex items-center justify-center min-h-screen bg-gradient-to-r from-gray-400 to-gray-50"
}
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"text-center p-8 bg-white rounded-lg shadow-2xl max-w-lg mx-auto\" data-v-5b9993a2><div class=\"mb-8\" data-v-5b9993a2><h1 class=\"text-9xl font-bold gradient-text\" data-v-5b9993a2>404</h1></div><div class=\"space-y-4\" data-v-5b9993a2><h2 class=\"text-3xl font-bold text-gray-800\" data-v-5b9993a2>¡Página no encontrada!</h2><p class=\"text-gray-600 text-lg\" data-v-5b9993a2> Lo sentimos, pero parece que el parámetro userdata no está presente en la URL. </p><div class=\"mt-8\" data-v-5b9993a2><p class=\"text-sm text-gray-500 mb-4\" data-v-5b9993a2> Asegúrate de incluir el parámetro userdata en la URL: </p><code class=\"bg-gray-100 p-3 rounded-lg text-sm text-gray-700 block\" data-v-5b9993a2> http://sitio.com?userdata=userdata_valido </code></div></div></div>", 1)
const _hoisted_5 = [
  _hoisted_4
]

import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import DataTable from '@/components/DataTable.vue';
import ApiService from '@/services/ApiService'


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const route = useRoute();
const hasValidUserData = ref(false);
const userdata = ref('');
const service = new ApiService()
const tasks = service.getTasks()
const countTaskByProcess = service.getCountTaskByProcess()
const loading = service.getLoadingState()
const currentStatus = ref('Pending');

/*
Carga los datos cuando se cambian los filtros entre pendiente y finalizar. 
*/
const handleStatusUpdate = async (newStatus: string) => {
    if (newStatus !== currentStatus.value) {
    currentStatus.value = newStatus;

    const userdataParam2 = route.query.UserData as string;
    const userdataParam = userdataParam2.replace(/ /g, '+');

    await service.fetchTaskNetApi(userdataParam, newStatus);

    //Para pruebas de forma local. 
    //console.log("HomeView: " + encodeURIComponent(userdata.value));
    //await service.fetchTasksOffline(userdata.value, newStatus);
  }
}

/*
Carga los datos cuando entra por primera vez a la página.  
O cuando se recarga la misma. 
*/
onMounted(async () => {
  const userdataParam2 = route.query.UserData as string;
  const userdataParam = userdataParam2.replace(/ /g, '+');

  hasValidUserData.value = Boolean(userdataParam && userdataParam !== '');

  if (hasValidUserData.value) {
    userdata.value = userdataParam;
    try {
      await service.fetchTaskNetApi(userdataParam, currentStatus.value);
      await service.fetchCountOfTasksByProcess(userdataParam, 'Finished');

      //Para pruebas de forma local. 
      //await service.fetchTasksOffline2();

    } catch (error) {
      console.error('Error loading tasks:', error);
    }
  }
})

return (_ctx: any,_cache: any) => {
  return (hasValidUserData.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createBlock(DataTable, {
            key: currentStatus.value,
            items: _unref(tasks),
            countTaskByProcess: _unref(countTaskByProcess),
            userdata: userdata.value,
            loading: _unref(loading),
            "onUpdate:status": handleStatusUpdate,
            hasError: false
          }, null, 8, ["items", "countTaskByProcess", "userdata", "loading"]))
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
}
}

})